<template>
    <div class="head case_f_head">
        <a href="javascript:void(0);" class="hd_logo">
            <img src="@/assets/head/logo.png" alt="" class="img img_pc" />
        </a>
        <em class="sj_menu"></em>
        <div class="hd_nav">
            <li><a href="/">首页</a>
            </li>
            <li><a href="">防伪溯源</a>
                <div class="hd_drop">
                    <a href="/znfw">智能防伪</a>
                    <a href="/trace">农产品追溯</a>
                </div>
            </li>
            <li><a href="/channel">渠道营销</a>
            </li>
            <li><a href="/case">合作案例</a>
            </li>
            <li><a href="/about">联系我们</a>
            </li>
        </div>

        <div class="search-box-wrap">
            <div class="search-box">
                <input type="text" placeholder="请输入防伪码" v-model.trim="searchCode" @keyup.enter="searchFn"
                    :disabled="loading">
                <button @click="searchFn" :disabled="loading">
                    <span v-if="!loading">防伪查询</span>
                    <span v-else>查询中...</span>
                </button>
            </div>
        </div>

        <div class="hd_admin">
            <a href="http://www.t.151m.net/login" class="link login">登录</a>
        </div>

        <!-- 结果卡片弹窗 -->
        <div class="result-card-modal" v-show="showToast" @click="closeToast">
            <div class="result-card" :class="showType" @click.stop>
                <div class="result-content">
                    {{ toastMsg }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: "Head",
    data() {
        return {
            searchCode: "",
            loading: false,
            // 提示框
            showToast: false,
            toastMsg: "",
            showType: ""
        }
    },
    methods: {
        // 美观提示
        showToastFun(msg, type) {
            this.toastMsg = msg;
            this.showType = type; // success / warning / error
            this.showToast = true;
            setTimeout(() => {
                this.showToast = false;
            }, 2800);
        },
        // 关闭卡片
        closeToast() {
            this.showToast = false
        },
        async searchFn() {
            if (!this.searchCode) {
                this.showToastFun("请输入防伪码", "error");
                return;
            }

            if (this.loading) return;
            this.loading = true;

            try {
                const res = await axios({
                    method: "post",
                    url: "https://151m.net/api/api/checkData/checkCode",
                    data: `code=${this.searchCode}`,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    },
                    responseType: "text"
                });

                const result = res.data.trim();

                switch (result) {
                    case "0":
                        this.showToastFun(`✅ 正品，首次查询\n防伪码：${this.searchCode}`, "success");
                        break;
                    case "1":
                        this.showToastFun(`⚠️ 正品，已多次查询\n防伪码：${this.searchCode}`, "warning");
                        break;
                    case "2":
                        this.showToastFun(`❌ 无效防伪码\n防伪码：${this.searchCode}`, "error");
                        break;
                    default:
                        this.showToastFun(`查询异常：${result}`, "error");
                }
            } catch (err) {
                console.error(err);
                this.showToastFun("网络异常，请稍后重试", "error");
            } finally {
                this.loading = false;
            }
        }
    }
}
</script>

<style>
.hd_nav>li>a {
    color: black;
}

.search-box-wrap {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 90px 0;
}

.search-box {
    display: flex;
    align-items: center;
}

.search-box input {
    width: 260px;
    height: 36px;
    padding: 0 12px;
    border: 1px solid #ddd;
    outline: none;
    font-size: 14px;
}

.search-box button {
    height: 36px;
    padding: 0 18px;
    background: #000;
    color: #fff;
    border: none;
    cursor: pointer;
    font-size: 14px;
}

/* 加大版结果卡片 */
.result-card-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.result-card {
    /* 卡片加宽加高 */
    width: 1100px;
    padding: 120px 100px;
    border-radius: 16px;
    color: #fff;
    /* 字体放大 */
    font-size: 60px;
    text-align: center;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
    animation: cardShow 0.3s ease;
    white-space: pre-line;
    line-height: 1.8;
}

@keyframes cardShow {
    from {
        opacity: 0;
        transform: scale(0.9);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

.result-card.success {
    background: #00c48c;
}

.result-card.warning {
    background: #ff9500;
}

.result-card.error {
    background: #ff3b30;
}
</style>